module.exports = "/_next/static/images/sprite-710618b0c2fad111383a86621b1ff57f.svg";